export const stringsKey = "NavigationDrawer";
export const englishStrings = {
	homePageMenu: "Home",
	templateLibraryViewPageMenu: "Batch Messages Library",
	adminMenu: "Admin",
	projectMenu: "Projects",
	awaitingApprovalMenu: "Batch Messages Awaiting Approval",
	templateList: "My Batch Messages",
	loginInfoMessage: "Loading, please wait...",
	variablesMenu: "Variables",
	scheduledTemplatesMenu: "Scheduled Batch Messages",
	userPermissionsMenu: "User Permissions",
};
